import { footerColumns } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-background-200">
      <div className="mx-auto max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-4">
            <a href="#top" className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 font-heading text-xl font-black text-background-50">
                17
              </span>
              <span className="font-heading text-xl font-black text-foreground-950">17黑料网</span>
            </a>
            <p className="mt-4 max-w-sm text-xs leading-relaxed text-foreground-600">
              聚焦代言人商务风险的公开信息整理站。以代言风险、合作避雷、品牌解约与公关危机为主线，
              为品牌方与市场人员提供一份可读、可追溯的舆情监控参考。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="flex items-center gap-1.5 rounded-md bg-background-100 px-3 py-2 text-[11px] text-foreground-600">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center text-primary-500"></i>
                contact@17heiliaowang.example
              </span>
              <span className="flex items-center gap-1.5 rounded-md bg-background-100 px-3 py-2 text-[11px] text-foreground-600">
                <i className="ri-time-line w-4 h-4 flex items-center justify-center text-primary-500"></i>
                每日 09:00 / 18:00 更新
              </span>
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <h4 className="font-heading text-sm font-bold text-foreground-950">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="whitespace-nowrap text-xs text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-bold text-foreground-950">风险等级说明</h4>
            <ul className="mt-4 space-y-3 text-xs text-foreground-600">
              <li className="flex items-center gap-2">
                <span className="h-2.5 w-2.5 rounded-sm bg-primary-500"></span>
                高风险 · 需立即排查
              </li>
              <li className="flex items-center gap-2">
                <span className="h-2.5 w-2.5 rounded-sm bg-accent-500"></span>
                中风险 · 持续观察
              </li>
              <li className="flex items-center gap-2">
                <span className="h-2.5 w-2.5 rounded-sm bg-secondary-500"></span>
                关注 · 已纳入监控
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 rounded-lg border border-background-300 bg-background-100 p-4">
          <p className="flex items-start gap-2 text-[11px] leading-relaxed text-foreground-500">
            <i className="ri-error-warning-line mt-0.5 w-4 h-4 flex items-center justify-center"></i>
            免责声明：本站内容来源于公开渠道的讨论与行业反馈整理，仅供品牌方与市场人员作合作风险评估参考，
            不对任何个人、品牌或机构作出事实认定与价值评判。如相关内容存在异议，请通过上方邮箱与我们联系。
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-background-300 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-[11px] text-foreground-500">
            © 2026 17黑料网 · 商务风险排查与舆情监控参考
          </p>
          <div className="flex flex-wrap gap-4 text-[11px] text-foreground-500">
            <a href="#top" className="hover:text-primary-600">数据说明</a>
            <a href="#method" className="hover:text-primary-600">监控方法论</a>
            <a href="#subscribe" className="hover:text-primary-600">风险预警订阅</a>
            <a href="#top" className="flex items-center gap-1 hover:text-primary-600">
              <i className="ri-arrow-up-line w-3.5 h-3.5 flex items-center justify-center"></i>
              回到顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}